import { GridSize } from "@material-ui/core"

export const numberToGridSize = (number: number) => {
    return Math.round(12 / number) as GridSize
}